import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryTankDetailsComponent } from 'src/app/components/inventory-tank-details/inventory-tank-details.component';
import { ServiceService } from 'src/app/services/service.service';

@Injectable({
  providedIn: 'root'
})
export class StationInventoryService {

  modalRef: any;

  constructor(private ngModal: NgbModal, private service: ServiceService) { }

  public openModalForTanks(item: any, readingsHistory: any, fromDate, toDate): void {
    $(".overlay-loading").show();
    
    this.service.findInventoryDeliveries(item.counter, item.tenant, 
      fromDate, toDate).subscribe(deliveries => {
      this.modalRef = this.ngModal.open(InventoryTankDetailsComponent,{
        size: 'lg',
        windowClass: 'modal-xxl' 
      });
      this.modalRef.componentInstance.selectedItem = item;
      this.modalRef.componentInstance.readings = readingsHistory[item.counter];
      this.modalRef.componentInstance.deliveries = deliveries;
      $(".overlay-loading").hide();
    })
    
  }

  closeModal(){
    this.modalRef.close();
  }
}
